
import { Fragment, } from "react";
import { Card, CardBody, CardHeader, Col, Container, Form, FormFeedback, FormGroup, Input, Label } from "reactstrap";

import Breadcrumb from "../../../components/common/breadcrumb";


import { Link, useNavigate } from "react-router-dom";

import { useForm } from "react-hook-form"
import axios from "../../../util/axiosInstance";

const BrandAdd = () => {
    const navigate = useNavigate()
    // const [addNewCategoryList] = useAddNewCategoryListQuery();

    const {
        register,
        handleSubmit,
        watch,
        reset,
        formState: { errors },
    } = useForm()

    const onSubmit = (data) => {
        
        axios.post('/brand/addbrand', data)
            .then(data => {
                reset();
                navigate('/product-management/brand-list/');
            })
            .catch(error => {
            });


    }

    return (
        <Fragment>
            <Breadcrumb title="Brand Add" parent="Product Management" />
            <Container fluid={true}>
                <Card>
                    <CardHeader>
                        <div>
                            <h5 className="text-center"> Please Enter Valid Data</h5>
                        </div>
                    </CardHeader>
                    <CardBody>
                        
                        <Form onSubmit={handleSubmit(onSubmit)}>

                            <FormGroup>
                                <Label for="exampleName">
                                    Brand Name
                                </Label>
                                <input className="form-control"  {...register("brand_name", { required: true })} />
                                {errors.brand_name && <span className="text-danger">This field is required</span>}
                            </FormGroup>

                            <FormGroup className="d-none">
                                <Label for="exampleName">
                                    Brand Status
                                </Label>
                                <input defaultValue={1} className="form-control"  {...register("status", { required: false })} />
                                {errors.status && <span className="text-danger">This field is required</span>}
                            </FormGroup>
                            <FormGroup row>
                                <Label
                                    for="exampleText"
                                >
                                    Description
                                </Label>
                                <Col>

                                    <textarea
                                        {...register("description", { required: false })}
                                        type="textarea"
                                        className="form-control"
                                    />
                                </Col>
                                {errors.description && <span className="text-danger">This field is required</span>}
                            </FormGroup>
                            
                            <div className="d-flex gap-5">
                            <input type="submit" style={{ backgroundColor: 'green', border: 'none', padding: '12px 20px', color: 'white', borderRadius: '5px' }} />
                            <Link to={'/dashboard'} style={{ backgroundColor: 'red',textDecoration:'none', border: 'none', padding: '12px 20px', color: 'white', borderRadius: '5px' }}> Close </Link>
                            </div>
                        </Form>

                    </CardBody>
                </Card>
            </Container>
        </Fragment>
    );
};

export default BrandAdd;
